<template>
  <div class="info-page edit-list-page">
    <Row id="printDom">
      <Col span="24">
        <Form ref="transValidate" id="transTableForm"
              class="list-form">
<!--              :rules="transValidate"-->
<!--              :model="transInfo"-->
          <Table ref="transTable"
                 :max-height="fixedHeader ? tableHeight : ''" :row-class-name="rowClassName"
                 :columns="transColumns" :data="transList" border show-summary :summary-method="handleSummary"
                 :loading="isListLoading">
            <template slot-scope="{ row, index }" slot="transDt">
              <span>{{ formatDateToDay(row.transDt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="transSummary">
              <span>{{ row.transSummary }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="entityId">
              <span>
                {{ (item = projSettleEntityList.find(entity => (entity.entityId === row.entityId))) ? item.entityName : '' }}
              </span>
            </template>

            <template slot-scope="{ row, index }" slot="contractAmt">
              <span>{{ formatThousandthNumber(row.contractAmt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="feeId">
              <span>{{ findItemDescrByValue(feeNameDDList, row.feeId) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="reimbOutputSettlAmt">
              <span>{{ formatThousandthNumber(row.reimbOutputSettlAmt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="reimbOfficialSettlAmt">
              <span>{{ formatThousandthNumber(row.reimbOfficialSettlAmt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="reimbTotalSettlAmt">
              <span>{{ formatThousandthNumber(row.reimbOutputSettlAmt + row.reimbOfficialSettlAmt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="payPlanAmt">
              <span>{{ formatThousandthNumber(row.payPlanAmt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="payDebtAmt">
              <span>{{ formatThousandthNumber(row.payDebtAmt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="payAmt">
              <span>{{ formatThousandthNumber(row.payAmt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="paymentId">
              <span>{{ findItemDescrByValue(projSettlePaymentDDList, row.paymentId) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="invAmt">
              <span>{{ formatThousandthNumber(row.invAmt) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="docIndex">
              <span>{{ '#' + formatIntMonth(row.docMth) + (row.docIndex ? '-' + row.docIndex : '') }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="transRemarks">
              <span>{{ row.transRemarks }}</span>
            </template>
          </Table>
        </Form>
      </Col>
    </Row>
  </div>
</template>

<script>
import * as Utils from '@/utils'
import SearchWrapper from '@/components/wrapper/SearchWrapper'

export default {
  components: {
    // Title
    SearchWrapper
  },
  props: {
    compId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    projId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    paramFeeId: {
      type: String,
      require: false,
      default: () => {
        return ''
      }
    },
    paramMonth: {
      type: Date,
      require: false,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      fixedHeader: true,
      tableHeight: 400,
      isListLoading: false,
      isShowPairSpin: false,
      // searchFormValidate: {
      //   searchType: [
      //     { required: true, message: this.$t('module.proj.projstatistic.searchValidateInfo.searchTypeRequired'), trigger: 'change' }
      //   ]
      // },
      // transValidate: {
      //   transDt: [
      //     { required: true, message: this.$t('module.proj.projsettletrans.validateInfo.transDtRequired'), trigger: 'change', pattern: /.+/ }
      //   ]
      // },
      pStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.85)',
        lineHeight: '24px',
        display: 'block',
        marginBottom: '16px'
      },
      transColumns: [
        {
          title: this.$t('module.proj.projsettletrans.info.transDt'),
          slot: 'transDt',
          align: 'center',
          width: 110,
          fixed: 'left'
        },
        {
          title: this.$t('module.proj.projsettletrans.info.transSummary'),
          slot: 'transSummary',
          key: 'transSummary',
          align: 'left',
          width: 100,
          fixed: 'left'
        },
        {
          title: this.$t('module.proj.projsettletrans.info.entityId'),
          slot: 'entityId',
          // key: 'entityId',
          align: 'center',
          width: 100,
          fixed: 'center'
        },
        {
          title: this.$t('module.proj.projsettletrans.info.contractAmt'),
          slot: 'contractAmt',
          key: 'contractAmt',
          align: 'right',
          width: 90
        },
        {
          title: this.$t('module.proj.projsettletrans.info.reimbSettl'),
          align: 'center',
          children: [
            {
              title: this.$t('module.proj.projsettletrans.info.feeId'),
              slot: 'feeId',
              align: 'center',
              width: 120
            },
            {
              title: this.$t('module.proj.projsettletrans.info.reimbOutputSettlAmt'),
              slot: 'reimbOutputSettlAmt',
              key: 'reimbOutputSettlAmt',
              align: 'right',
              width: 80
            },
            {
              title: this.$t('module.proj.projsettletrans.info.reimbOfficialSettlAmt'),
              slot: 'reimbOfficialSettlAmt',
              key: 'reimbOfficialSettlAmt',
              align: 'right',
              width: 80
            },
            {
              title: this.$t('module.proj.projsettletrans.info.reimbTotalSettlAmt'),
              slot: 'reimbTotalSettlAmt',
              key: 'reimbTotalSettlAmt',
              align: 'right',
              width: 80
            }
          ]
        },
        {
          title: this.$t('module.proj.projsettletrans.info.payment'),
          align: 'center',
          children: [
            {
              title: this.$t('module.proj.projsettletrans.info.payPlanAmt'),
              slot: 'payPlanAmt',
              key: 'payPlanAmt',
              align: 'right',
              width: 80
            },
            {
              title: this.$t('module.proj.projsettletrans.info.payDebtAmt'),
              slot: 'payDebtAmt',
              key: 'payDebtAmt',
              align: 'right',
              width: 90
            },
            {
              title: this.$t('module.proj.projsettletrans.info.payAmt'),
              slot: 'payAmt',
              key: 'payAmt',
              align: 'right',
              width: 80
            },
            {
              title: this.$t('module.proj.projsettletrans.info.paymentId'),
              slot: 'paymentId',
              align: 'center',
              width: 120
            }
          ]
        },
        {
          title: this.$t('module.proj.projsettletrans.info.invAmt'),
          slot: 'invAmt',
          key: 'invAmt',
          align: 'right',
          width: 80
        },
        {
          title: this.$t('module.proj.projsettletrans.info.docIndex'),
          slot: 'docIndex',
          align: 'left',
          width: 100
        },
        {
          title: this.$t('module.proj.projsettletrans.info.transRemarks'),
          slot: 'transRemarks',
          align: 'center',
          minWidth: 80
        }
      ],
      selectedRecord: {},
      selectedIndex: -1,
      END_DATA: null
    }
  },
  computed: {
    // authedFnKeyMap() {
    //   return this.$store.state.systemAuthManage.authedFnKeyMap
    // },
    searchedForm() {
      return this.$store.state.projSettleTransManage.searchedForm
    },
    searchInfo() {
      return this.$store.state.projSettleTransManage.searchInfo
    },
    searchType: {
      get() {
        return this.searchInfo.searchType
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchType', value)
      }
    },
    searchMonth: {
      get() {
        return this.searchInfo.searchMonth
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchMonth', value)
      }
    },
    searchMonthType: {
      get() {
        return this.searchInfo.searchMonthType
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchMonthType', value)
      }
    },
    searchDtScope: {
      get() {
        return this.searchInfo.searchDtScope
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchDtScope', value)
      }
    },
    searchFeeId: {
      get() {
        return this.searchInfo.searchFeeId
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchFeeId', value)
      }
    },
    searchPaymentId: {
      get() {
        return this.searchInfo.searchPaymentId
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchPaymentId', value)
      }
    },
    searchDocMth: {
      get() {
        return this.searchInfo.searchDocMth
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchDocMth', value)
      }
    },
    searchDocIndex: {
      get() {
        return this.searchInfo.searchDocIndex
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchDocIndex', value)
      }
    },
    searchDocMonthIndex: {
      get() {
        return this.searchInfo.searchDocMonthIndex
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchDocMonthIndex', value)
      }
    },
    searchDocType: {
      get() {
        return this.searchInfo.searchDocType
      },
      set(value) {
        this.$store.commit('projSettleTransManage/updateSearchDocType', value)
      }
    },
    // trans
    // transInfo() {
    //   return this.$store.state.projSettleTransManage.transInfo
    // },
    feeNameDDList() {
      return this.$store.state.rspFeeNameManage.feeNameDDList
    },
    transList() {
      return this.$store.state.projSettleTransManage.transList
    },
    projSettlePaymentDDList() {
      return this.$store.state.confProjSettlePaymentManage.projSettlePaymentDDList
    },
    projSettleEntityList() {
      return this.$store.state.confProjSettleEntityManage.projSettleEntityList
    },
    END_COMPUTED() {
      return null
    }
  },
  methods: {
    formatI18nValue(prefix, value) {
      return value ? this.$t(prefix + value) : null
    },
    initFormValue() {
      this.$store.commit('projSettleTransManage/resetSearchInfo')
      this.searchType = 'MONTH'
      this.searchMonth = this.paramMonth
      this.searchMonthType = 'TOTAL'
      this.searchFeeId = this.paramFeeId
    },
    cleanForm() {
      this.$store.commit('projSettleTransManage/updateProjSettleTransListEmpty')
    },
    getKeyParam() {
      return { projId: this.projId, compId: this.compId }
    },
    isActiveItem: Utils.isActiveItem,
    // isUsedItem: Utils.isUsedItem,
    // formatDate: Utils.formatDate,
    formatDateToDay: Utils.formatDateToDay,
    // formatDateToMonth: Utils.formatDateToMonth,
    formatDateToMonthInt: Utils.formatDateToMonthInt,
    formatIntMonth: Utils.formatIntMonth,
    findItemDescrByValue: Utils.findItemDescrByValue,
    // parseDate: Utils.parseDate,
    getMonthFirstDay: Utils.getMonthFirstDay,
    getMonthLastDay: Utils.getMonthLastDay,
    formatThousandthNumber: Utils.formatThousandthNumber,
    parserThousandthNumber: Utils.parserThousandthNumber,
    // formatThousandthNumberAllowZero: Utils.formatThousandthNumberAllowZero,
    rowClassName(row, index) {
      let clz = ''
      if (row.colType === 'BEFORE_SUMMARY') {
        clz += ' table-column-row'
      }

      return clz
    },
    async refreshList() {
      this.isListLoading = true
      // console.info('searchInfo:', this.searchInfo)
      // console.info('searchedForm:', this.searchedForm)
      this.$store.commit('projSettleTransManage/updateProjSettleTransListEmpty')
      const result = await this.$store.dispatch('projSettleTransManage/findProjSettleTransListByFeeId', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
      if (result.success) {
        await this.$store.commit('projSettleTransManage/updateProjSettleTransList', result.data)
      }
      this.isListLoading = false
    },
    handleSummary({ columns, data }) {
      const sums = {}
      data = data.filter(item => (item.colType !== 'PERIOD_AMOUNT'))
      columns.forEach((column, index) => {
        const key = column.key
        if (!key) {
          sums[key] = {
            key,
            value: ''
          }
          return
        }
        if (index === 1) {
          sums[key] = {
            key,
            value: this.$t('common.commonVar.total')
          }
          return
        }
        let values = []
        if (key === 'reimbTotalSettlAmt') {
          values = values.concat(data.map(item => Number(item['reimbOutputSettlAmt'])))
          values = values.concat(data.map(item => Number(item['reimbOfficialSettlAmt'])))
        } else {
          values = data.map(item => Number(item[key]))
        }
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[key] = {
            key,
            value: this.formatThousandthNumber(v)
          }
        } else {
          sums[key] = {
            key,
            value: 'N/A'
          }
        }
      })

      return sums
    },
    async goSearch() {
      this.isShowPairSpin = true
      await this.doSearchProcess()
      this.isShowPairSpin = false
    },
    async doSearchProcess() {
      await this.$store.commit('projSettleTransManage/updateSearchedForm')
      await this.refreshList()
    },
    END_METHODS() {}
  },
  async mounted() {
    // console.info('compId: ', this.compId)
    // console.info('projId: ', this.projId)
    // console.info('paramFeeId: ', this.paramFeeId)
    // console.info('paramMonth: ', this.paramMonth)
    this.cleanForm()

    // await this.$store.dispatch('systemAuthManage/findProjAuth', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.$store.dispatch('confProjSettleEntityManage/findProjSettleEntityList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.$store.dispatch('rspFeeNameManage/findRspFeeNameDDList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
    await this.$store.dispatch('confProjSettlePaymentManage/findProjSettlePaymentDDList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})

    this.initFormValue()

    await this.goSearch()
  },
  async destroyed() {
    this.cleanForm()
  }
}
</script>

<style lang="less">
  /*@import '../../../theme/index.less';*/

  .edit-list-page .ivu-form-item {
    width: 100%;
  }
  .edit-list-page .search-wrapper .ivu-input-wrapper {
    width: 100% !important;
  }
  .edit-cls {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/proj/FeeSettleTransListCard.vue